export default __webpack_public_path__ + "static/media/Rectangle 1012.e220402a.png";